import charging from '../../charging';

// Deprecated
export function resetChargepoint(data) {
  return charging.post('/reset_chargepoint', data);
}
